import React from 'react';

const H1 = (props) => {
  return <h1>{props.children}</h1>;
};

const H2 = (props) => {
  return <h2>{props.children}</h2>;
};

const H3 = (props) => {
  return <h3>{props.children}</h3>;
};

const H4 = (props) => {
  return <h4>{props.children}</h4>;
};

const H5 = (props) => {
  return <h5>{props.children}</h5>;
};

export { H1, H2, H3, H4, H5 };
